import { SupportCustomersColumnKey, ColumnConfig } from '../model';

export const supportCustomers: Record<SupportCustomersColumnKey, ColumnConfig> =
  {
    customerName: { name: 'Customer Name' },
    customerCode: { name: 'Customer Code' },
    role: { name: 'Role' },
    accountStatus: { name: 'Account Status' },
    select: { name: '', field: 'textWithImage' },

    action: {
      name: '',
      field: 'component',
    },
  };
